/**
 * 设置cookie
 * @author @zhaobing
 * @param {String} key
 * @param {String} value
 * @param {Object} opt
 * @property {String} opt.path - 例如 '/', '/mydir') 如果没有定义，默认为'/'。
 * @property {String} opt.domain - (例如 'example.com'， '.example.com' (包括所有子域名),
 *  'subdomain.example.com') 如果没有定义，默认为当前文档位置的路径的域名部分。
 * @property {String} opt.maxAge - max-age-in-seconds (例如一年为60*60*24*365)
 * @property {String} opt.expires - 过期时间，不需要转换成UTC
 * @property {String} opt.secure - cookie只通过https协议传输，默认为false
 */
export function setCookie(
  key,
  value,
  { path = '/', domain = '.xunlei.com', maxAge, expires, secure } = {}
) {
  let cookieStr = key + '=' + encodeURIComponent(value)

  path && (cookieStr += ';path=' + path)
  domain && (cookieStr += ';domain=' + domain)
  maxAge && (cookieStr += ';max-age=' + maxAge)
  if (expires) {
    const date = new Date()
    date.setTime(date.getTime() + expires * 24 * 60 * 60 * 1000)
    cookieStr += ';expires=' + date.toUTCString()
  }
  secure && (cookieStr += ';secure=' + secure)

  document.cookie = cookieStr
}

/**
 * @method getCookie
 * @desc 获取cookie值
 * @param name {String} - cookie字段名
 * @returns {String} - cookie值
 */
export function getCookie(
  name,
  cookie = process.client ? document.cookie : ''
) {
  const result =
    cookie.match(new RegExp('(^' + name + '| ' + name + ')=([^;]*)')) == null
      ? ''
      : RegExp.$2

  return result
}

export function removeCookie(name) {
  document.cookie = name + '=;path=/;domain=.xunlei.com'
}

export default (_, inject) => {
  inject('cookies', {
    get: getCookie,
    set: setCookie,
    remove: removeCookie
  })
}
